<template>
  <section class="hit-calculator-checkboxes-collapsed-by-default-settings settings">
    <header>
      <h1 class="page-header">Hit calculator checkboxes collapsed by default</h1>
    </header>
    <!-- made hands -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-10 col-sm-3">Made hand</th>
          <th class="col-xs-2 col-sm-3">Collapsed by default</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="madeHandParent in madeHandParents">
          <td v-html="madeHandParent.breadcrumbText"></td>
          <td><input v-model="collapsedByDefault[madeHandParent.id]" type="checkbox"></td>
        </tr>
      </tbody>
    </table>

    <!-- draws -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-10 col-sm-3">Draw</th>
          <th class="col-xs-2 col-sm-3">Collapsed by default</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="drawParent in drawParents">
          <td v-html="drawParent.breadcrumbText"></td>
          <td><input v-model="collapsedByDefault[drawParent.id]" type="checkbox"></td>
        </tr>
      </tbody>
    </table>

    <!-- combos collapsed by default -->
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="col-xs-10 col-sm-3">Combo</th>
          <th class="col-xs-2 col-sm-3">Collapsed by default</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="comboParent in comboParents">
          <td v-html="comboParent.breadcrumbText"></td>
          <td><input v-model="collapsedByDefault[comboParent.id]" type="checkbox"></td>
        </tr>
      </tbody>
    </table>

    <hr>
    <section class="buttons">
      <button class="btn btn-default btn-lg" v-on:click="isHelpVisible = !isHelpVisible">
        <span v-if="!isHelpVisible">Show help <span class="caret-down"></span></span>
        <span v-if="isHelpVisible">Hide help <span class="caret-up"></span></span>
      </button>
      <button class="btn btn-primary btn-lg" v-on:click="save()">
        Save
      </button>
    </section>
    <section v-if="isHelpVisible" class="well">
      Example use case:
      <ul>
        <li>If you find yourself usually checking all flush draws or checking no flush draws, you may want to have flush draws collapsed by default so that the specific types of flush draws (nut, second nut, third nut and weak) don't crowd the screen.</li>
        <li>If you find yourself usually distinguishing between, say, nut flush draws and weak flush draws, you may not want to have flush draws collapsed by default.</li>
      </ul>
      <hr>
      <img src="/static/settings/hit-calculator-checkboxes-collapsed-1.png">
      <img src="/static/settings/hit-calculator-checkboxes-collapsed-2.png">
    </section>
  </section>
</template>

<script>
import _ from 'lodash';
import FiveCardHands from '@/services/five-card-hands/FiveCardHands';

export default {
  name: 'hit-calculator-checkboxes-collapsed-by-default-settings',
  data: function () {
    return {
      collapsedByDefault: _.cloneDeep(this.$store.state.account.user.settings.hitCalculator.collapsedByDefault),
      isHelpVisible: false,
    };
  },
  computed: {
    madeHandParents: function () {
      let fiveCardHands = new FiveCardHands();

      return fiveCardHands.madeHands.flatArrayOfParents;
    },
    drawParents: function () {
      let fiveCardHands = new FiveCardHands();

      return fiveCardHands.draws.flatArrayOfParents;
    },
    comboParents: function () {
      let fiveCardHands = new FiveCardHands();

      return fiveCardHands.combos.flatArrayOfParents;
    },
  },
  methods: {
    save: function () {
      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.collapsedByDefault = this.collapsedByDefault;
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';

  img {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/hit-calculator/checkboxes/collapsed-by-default.vue